import SubTitle from '@/pages/WgqAllMaps/components/SubTitle';
import { EchartsWithTheme, Empty, Key, Tabs, useTheme } from '@maxtropy/components';
import { EchartsWithThemeRef } from '@maxtropy/components/es/components/EchartsWithTheme';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { ShareDataUnityEnergyCockpitMapContext } from '../../../..';
import { getAllChartOption, getChartOption, getElecChartOption } from './charts';
import styles from './index.module.scss';
import titlePng from '@/assets/images/title_icon.png';
import { formatName, getEnergyMediumColorMap } from '@/pages/WgqAllMaps/utils';

const CostTrend = () => {
  const theme = useTheme();
  const {
    timeResolution,
    energyCostData,
    energyCostDataLoading: loading,
  } = useContext(ShareDataUnityEnergyCockpitMapContext);
  const [tabActiveKey, setTabActiveKey] = useState<Key>();
  const chartRef = useRef<EchartsWithThemeRef>(null);

  useEffect(() => {
    if (!energyCostData) return;
    setTabActiveKey(energyCostData?.comprehensiveCost?.[0]?.energyMediumId?.toString());
  }, [energyCostData]);

  // 每个tab数据
  const itemDatas = useMemo(() => {
    return energyCostData?.comprehensiveCost?.find(i => String(i.energyMediumId) === tabActiveKey)?.mediumCostList;
  }, [energyCostData, tabActiveKey]);

  const energyMediumColorMap = useMemo(() => {
    const costFromMediums =
      energyCostData?.costFrom?.map(item => ({
        energyMediumId: item.energyMediumId,
        energyMediumName: item.energyMediumName,
      })) ?? [];

    if (costFromMediums.length > 0) {
      return getEnergyMediumColorMap(costFromMediums);
    }

    const detailMediums =
      energyCostData?.comprehensiveCost
        ?.flatMap(item => item.mediumCostList ?? [])
        .flatMap(item => item.detailList ?? [])
        .map(item => ({
          energyMediumId: item.energyMediumId,
          energyMediumName: item.energyMediumName,
        })) ?? [];

    return getEnergyMediumColorMap(detailMediums);
  }, [energyCostData]);

  // 电能
  const chartOption = useMemo(() => {
    if (tabActiveKey === '2030') {
      return getElecChartOption(itemDatas, timeResolution);
    } else if (tabActiveKey === '-1') {
      return getAllChartOption(itemDatas, timeResolution, energyMediumColorMap);
    } else {
      return getChartOption(itemDatas, timeResolution);
    }
  }, [energyMediumColorMap, itemDatas, tabActiveKey, timeResolution]);

  return (
    <SubTitle title="成本趋势" img={titlePng} style={{ flex: 11, padding: 0 }} headerStyle={{ paddingBottom: 4 }}>
      <div className={styles.bottomStyles}>
        <Tabs
          className={styles.tabsStyle}
          activeKey={tabActiveKey as string}
          getPopupContainer={() => document.getElementById('full_screen_box') ?? document.body}
          onChange={v => {
            setTabActiveKey(v);
          }}
          items={(energyCostData?.comprehensiveCost ?? []).map(i => {
            return {
              label: formatName(i.energyMediumName),
              key: String(i.energyMediumId),
            };
          })}
        />
      </div>
      <div style={{ flex: 1 }}>
        <EchartsWithTheme
          empty={{
            isShowEmpty: !itemDatas || itemDatas.length === 0,
            emptyNode: <Empty />,
          }}
          ref={chartRef}
          loading={loading}
          theme={theme}
          style={{ height: '100%', minHeight: 230 }}
          option={chartOption}
        />
      </div>
    </SubTitle>
  );
};

export default CostTrend;
